import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography
} from "@mui/material";
import { Link } from "react-router-dom";
import { formataDataLegal } from "../../shared/dataUtil";
import {
  estadoVisualEnvio,
  resumoEnvio,
  tituloEnvio
} from "../../shared/envioGatewayUtil";
import { useQuery } from "../../shared/useQueryParam";
import IconEstado from "../estado/IconEstado";

function PainelEnviosGateway({ envios }) {
  const query = useQuery();

  if (!envios) return null;

  return (
    <List component={Paper} sx={{ padding: 0 }}>
      {envios.map((envio) => (
        <ListItem
          key={envio.id}
          sx={{ borderBottom: "1px rgb(224, 224, 224) solid" }}
          button
          component={Link}
          to={`/eventos/${envio.id}?${query.toString()}`}
          secondaryAction={
            <ListItemText
              secondary={formataDataLegal(envio.criadoEm)}
              sx={{ whiteSpace: "nowrap" }}
            />
          }
        >
          <ListItemIcon>
            <IconEstado estado={estadoVisualEnvio(envio.estado)} />
          </ListItemIcon>
          <Grid container direction="column">
            <Grid item>
              <ListItemText
                primary={tituloEnvio(envio)}
                secondary={
                  <Grid container spacing={1}>
                    {resumoEnvio(envio).map(([label, value]) => (
                      <Grid item key={label}>
                        <Typography component="span" variant="body2">
                          <strong>{label}:</strong> {value}
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                }
                primaryTypographyProps={{ sx: { fontWeight: "500" } }}
              />
            </Grid>
            {envio.descricao && (
              <Grid item>
                <Typography color="text.secondary" variant="body2">
                  {envio.descricao}
                </Typography>
              </Grid>
            )}
          </Grid>
        </ListItem>
      ))}
    </List>
  );
}

export default PainelEnviosGateway;
